import React, {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import {ApiError, ApiService} from "../../../service/ApiService";
import {settingResultType} from "../../../types/Api/SettingResultType";

type FormDataType = {
  licence_year: string;
  licence_deadline: string;
}

// Paramètres de la page Licence, chacun stocké dans un `setting` du même nom
const SETTINGS: (keyof FormDataType)[] = ['licence_year', 'licence_deadline'];

export const LicenceSettingForm = () => {
  const [saved, setSaved] = useState(false);
  const {
    register,
    handleSubmit,
    setError,
    reset,
    watch,
    formState: {errors}
  } = useForm<FormDataType>();

  useEffect(() => {
    Promise.all(SETTINGS.map((key) => ApiService.get(`/setting/${key}`) as Promise<settingResultType>))
      .then(([year, deadline]: settingResultType[]) => reset({
        licence_year: year.value ?? '',
        licence_deadline: deadline.value ?? '',
      }))
      .catch(() => alert("Une erreur c'est produite."));
  }, [reset]);

  const year: string = (watch('licence_year') ?? '').trim();

  const onSubmit = async (data: FormDataType) => {
    setSaved(false);

    const results = await Promise.allSettled(SETTINGS.map((key) =>
      ApiService.patch(`/setting/${key}`, { param: () => ({value: data[key].trim()}) })
    ));

    results.forEach((r, i: number) => {
      if (r.status === 'rejected') {
        const error: ApiError = r.reason as ApiError;

        setError(SETTINGS[i], {type: "manual", message: error.errors?.[0]?.message ?? "Une erreur c'est produite."});
      }
    });

    setSaved(results.every((r) => r.status === 'fulfilled'));
  }

  return (
    <form className="mb-4" method="post" onSubmit={handleSubmit(onSubmit)}>
      <div className="d-flex align-items-end flex-wrap">
        <div className="me-3 mb-2">
          <label className="form-label" htmlFor="form-licence-year">Année de la licence</label>
          <input id="form-licence-year" type="text" maxLength={20} className="form-control w200px" placeholder="2026 / 2027" {...register('licence_year', {
            required: "L'année est requise",
            validate: {
              maxLength: (value) =>
                value.trim().length <= 20 || "L'année ne doit pas dépasser 20 caractères",
            },
            onChange: () => setSaved(false),
          })} />
        </div>
        <div className="me-3 mb-2">
          <label className="form-label" htmlFor="form-licence-deadline">Date limite de renouvellement</label>
          <input id="form-licence-deadline" type="date" className="form-control w200px" {...register('licence_deadline', {
            required: 'La date limite est requise',
            onChange: () => setSaved(false),
          })} />
        </div>
        <div className="mb-2">
          <button className="btn btn-sm btn-success me-3" type="submit">Enregistrer</button>
          {year !== '' && (
            <span className="text-muted">Affichée « Licence {year} »</span>
          )}
          {saved && <i className="fa-solid fa-check text-success ms-2"/>}
        </div>
      </div>
      {errors.licence_year && <p className="text-danger">{errors.licence_year.message}</p>}
      {errors.licence_deadline && <p className="text-danger">{errors.licence_deadline.message}</p>}
    </form>
  );
}
